/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupContractWithMembersDto } from './GroupContractWithMembersDto';
import {
    GroupContractWithMembersDtoFromJSON,
    GroupContractWithMembersDtoFromJSONTyped,
    GroupContractWithMembersDtoToJSON,
    GroupContractWithMembersDtoToJSONTyped,
} from './GroupContractWithMembersDto';

/**
 * 
 * @export
 * @interface SearchGroupContractMembersResponse
 */
export interface SearchGroupContractMembersResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchGroupContractMembersResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<GroupContractWithMembersDto>}
     * @memberof SearchGroupContractMembersResponse
     */
    items: Array<GroupContractWithMembersDto>;
}

/**
 * Check if a given object implements the SearchGroupContractMembersResponse interface.
 */
export function instanceOfSearchGroupContractMembersResponse(value: object): value is SearchGroupContractMembersResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function SearchGroupContractMembersResponseFromJSON(json: any): SearchGroupContractMembersResponse {
    return SearchGroupContractMembersResponseFromJSONTyped(json, false);
}

export function SearchGroupContractMembersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchGroupContractMembersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(GroupContractWithMembersDtoFromJSON)),
    };
}

export function SearchGroupContractMembersResponseToJSON(json: any): SearchGroupContractMembersResponse {
    return SearchGroupContractMembersResponseToJSONTyped(json, false);
}

export function SearchGroupContractMembersResponseToJSONTyped(value?: SearchGroupContractMembersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(GroupContractWithMembersDtoToJSON)),
    };
}

